export const BLOCK_NAME = 'b-interview'

export const NAMESPACE = {
  js: `${BLOCK_NAME}_js`,
  card: `${BLOCK_NAME}__card`,
  name: `${BLOCK_NAME}__name`,
  answer: `${BLOCK_NAME}__answer`,
}

// Высота которая будет задана контенту (заголовок + текст интервью)
export const CONTENT_HEIGHT = 280
